import * as _ from 'lodash'
import React, { useEffect, useState } from 'react';
import componentServices from '../componentServices';
import { useJobCostItemDragDrop } from '../draggableJobCostLineItem';
import valueFilters from '../valueFilters';
import util from '../util';
import keyboardUtil from 'Scripts/keyboardUtils';
import enums from '../enum';
import * as vendorActions from '../vendorActions';
import { AsyncButton, CurrencyInput, Header, jobCostRowOwner, JobCostHiddenWhenLocked, NumericInput, PercentInput } from './sharedComponents';
import { IJobCostChildProps } from './jobCostEdit';
import { getCollection, ModelCollection } from 'Scripts/store';

const _showOnContractFlags = ['Contract_With_Price', 'Contract_Without_Price', 'Contract_Hidden'];
const _jobCostLineItemTypes = ['outside-supplier', 'warehouse', 'misc'];
const KEY_DOWN_CODES = [13];

const StandardWarehouseRow = ({ buttonClass, contractOptions, disableEntry, disableItemEntry, dragHandle, 
	itemOptions, lineItem, handleButtonClick, validate, handleUpdate, workAreaOptions }) => {

	return (<React.Fragment>
		<td />
		<td>{dragHandle}</td>
		<td colSpan={ 2 } className={(!validate('productName') ? 'required' : '')}>
			<input disabled={disableItemEntry} type="text" className={ 'dataList ' + disableItemEntry } 
				list={'item_' + lineItem.key} name="item" placeholder="Enter or Select" 
				value={lineItem.viewValue('productName')} 
				onChange={e => handleUpdate('productName', false, e)} 
				onBlur={e => handleUpdate('productName', true, e)} 
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
			<datalist id={'item_' + lineItem.key}>
				{ itemOptions }
			</datalist>
		</td>
		<td className={(!validate('workAreaKey') ? 'required ' + disableEntry : ' ' + disableEntry)}>
			<select disabled={disableItemEntry} className={ 'select ' + disableItemEntry } placeholder="Select" value={lineItem.viewValue('workAreaKey')} onChange={e => handleUpdate('workAreaKey', true, e)}>
				{ workAreaOptions }
			</select>
		</td>
		<td className={(!validate('description') ? 'required' : '')}>
			<input disabled={disableEntry} className={ disableEntry } type="text" placeholder="Enter" 
				autoCapitalize="" autoCorrect="off" value={lineItem.viewValue('description')} 
				onChange={e => handleUpdate('description', false, e)} 
				onBlur={e => handleUpdate('description', true, e)} 
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className="centered">
			<input disabled={disableEntry} className={ disableEntry } type="checkbox" checked={lineItem.isOptional} 
				onChange={e => handleUpdate('isOptional', true, e)} />
		</td>
		<td>
			<select className={'select ' + disableEntry} disabled={disableEntry} placeholder="Select" value={ lineItem.contractVisibility } onChange={e => handleUpdate('contractVisibility', true, e)}>
				{ contractOptions }
			</select>
		</td>
		<td className="cost">
			<CurrencyInput disabled={disableEntry} className={ disableEntry } type="text" placeholder="0" 
				value={lineItem.viewValue('cost')} 
				onChange={e => handleUpdate('cost', false, e)} 
				onBlur={e => handleUpdate('cost', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className={'quantity ' + ' ' + (!validate('quantity') ? 'required' : '')}>
			<NumericInput disabled={disableEntry} className={ disableEntry } type="text" placeholder="0" min="0" 
				value={lineItem.viewValue('quantity')} 
				onChange={e => handleUpdate('quantity', false, e)} 
				onBlur={e => handleUpdate('quantity', true, e)} 
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className="cost"><span className="readOnly">{ util.formatAsCurrency(lineItem.totalCost) }</span></td>
		<td className={'margin ' + ' ' + (!validate('margin') ? 'required' : '')}>
			<PercentInput disabled={disableEntry} className={ disableEntry } type="text" placeholder="0" 
				value={lineItem.viewValue('margin')} 
				onChange={e => handleUpdate('margin', false, e)} 
				onBlur={e => handleUpdate('margin', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td className="cost">
			<CurrencyInput disabled={disableEntry} className={ disableEntry } type="text" placeholder="0" 
				value={lineItem.viewValue('sellPrice')} 
				onChange={e => handleUpdate('sellPrice', false, e)} 
				onBlur={e => handleUpdate('sellPrice', true, e)}
				onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
		</td>
		<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
		<td />
	</React.Fragment>);
};

const SystemManagedWarehouseRow = ({ buttonClass, dragHandle, lineItem, handleButtonClick }) => {
	return (<React.Fragment>
		<td />
		<td>{dragHandle}</td>
		<td colSpan={ 2 } className=""><span className="readOnly">{ lineItem.productName }</span>
		</td>
		<td>
			<span className="readOnly">–</span>
		</td>
		<td className="">
			<span className="readOnly">{ lineItem.description }</span>
		</td>
		<td className="centered">
			<span className="readOnly">–</span>
		</td>
		<td className="centered">
			<span className="readOnly">–</span>
		</td>
		<td>
			<span className="readOnly">{ enums.jobCostLineItemReportingFlags.getDisplayName(lineItem.contractVisibility) }</span>
		</td>
		<td className="cost">
			<span className="readOnly">{ util.formatAsCurrency(lineItem.cost) }</span>
		</td>
		<td className="quantity  ">
			<span className="readOnly">{ lineItem.quantity }</span>
		</td>
		<td className="cost">
			<span className="readOnly">{ util.formatAsCurrency(lineItem.totalCost) }</span>
		</td>
		<td className="margin">
			<span className="readOnly">{ (lineItem.margin * 100).toFixed(2) }</span>
		</td>
		<td className="cost">
			<span className="readOnly">{ util.formatAsCurrency(lineItem.sellPrice) }</span>
		</td>
		<td>
			<button className={buttonClass} onClick={handleButtonClick} title={ lineItem.itemNote }><span /></button>
		</td>
		<td />
	</React.Fragment>);
};

function JobCostAccessoriesRow(props) {
	const { alwaysValidate, buttonHandler, classNames = [], dropLineItem, buttonClass, draggable, lineItem, updateModel, workAreas, vendors } = props;
	const [shouldValidate, setShouldValidate] = useState(alwaysValidate);
	const [{isDragging, dragSourceRef, dragPreviewRef, dropItem, dropTargetRef, rowRef}] = useJobCostItemDragDrop({ 
		item: lineItem,
		handleDrop: (dragItem, dropItem) => dropLineItem(dragItem.key, dropItem.key) 
	});
	let dropClass:any = null;
	const dragClass = isDragging ? 'disabled' : null;

	if (dropItem) {
		const dropIndex = lineItem.sortIndex;
		const dragIndex = dropItem.sortIndex;

		dropClass = (dropIndex > dragIndex) ? 'dropBottom' : 'dropTop';
	}

	const rowClasses = _.concat(classNames, dropClass, dragClass);
	const dragHandle = (draggable) ? <button ref={ dragSourceRef } className="icon iconOnly drag"><span /></button> : null;

	function handleUpdate (path, autoSave, e) {
		let newVal;
		if (e.target.type === 'checkbox') {
			newVal = e.target.checked;
		}
		else {
			newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;
		}

		updateModel((model, updateCallback) => {
			if (path === 'productName') {
				if (vendors) {
					const vendor = vendors.find(v => v.key === model.vendorKey);
					if (vendor) {
						const product = vendor.getProductBySku(newVal);
						model.productKey = (product) ? product.key : undefined;
						model.description = (product) ? product.name : undefined;
					}
				}
			}

			if (path === 'vendorKey') {
				model.description = undefined;
				model.productKey = undefined;
				model.productName = undefined;
				model.workAreaKey = undefined;
				model.cost = 0;
				model.quantity = 1;
				model.sellPrice = 0;
			}

			if (path === 'isOptional' && newVal) {
				model.contractVisibility = enums.jobCostLineItemReportingFlags.Contract_With_Price;
			}

			model.setAt(path, newVal);

			updateCallback(model, path);
		}, { autoSave: autoSave });
	}

	function validate (property?) {
		if (!property || shouldValidate) {
			const result = !lineItem.test(property);

			return result;
		}
		return true;
	}

	function handleButtonClick (e) {
		e.preventDefault();

		const valid = isValidEvent();
		buttonHandler(valid, e);
	}

	function isValidEvent() {
		const valid = validate();

		if (!valid) {
			setShouldValidate(true);
		}
		else {
			// this assumes that the add handler succeeds
			setShouldValidate(alwaysValidate);
		}
		return valid;
	}
	const renderer = {
		render_outside_supplier () { // eslint-disable-line camelcase
		// Define the vendor options list
			const vendorOptions:JSX.Element[] = [];

			vendorOptions.push(<option key="unknown">Select</option>);

			vendors.forEach(v => {
				if (v.type === enums.vendorTypes.Outside_Supplier) {
					vendorOptions.push(<option key={v.key} value={v.key}>{v.name}</option>);
				}
			});

			// Define the item options list
			let disableItemEntry = 'disabled';
			const itemOptions:JSX.Element[] = [];
			const vendor = vendors.find(v => v.key === lineItem.vendorKey);

			if (vendor) {
				_.forEach(_.sortBy(vendor.products, 'sku'), product => {
					itemOptions.push(<option key={product.key}>{product.sku}</option>);
				});

				disableItemEntry = '';
			}

			// Define the work area options list
			const workAreaOptions:JSX.Element[] = [];

			workAreaOptions.push(<option key="unknown" value="">Select</option>);
			_.forEach(workAreas, workArea => {
				workAreaOptions.push(<option key={workArea.key} value={workArea.key}>{workArea.name}</option>);
			});

			const contractOptions:JSX.Element[] = [];
			_showOnContractFlags.forEach(flag => {
				const val = enums.jobCostLineItemReportingFlags[flag];
				const displayName = enums.jobCostLineItemReportingFlags.getDisplayName(val);
				contractOptions.push(<option key={val} value={val}>{ displayName }</option>);
			});

			let disableEntry = 'disabled';
			if (vendor && lineItem.productName) {
				disableEntry = (lineItem.productName === undefined) ? disableEntry : '';
			}

			return <tr ref={ rowRef }className={rowClasses.join(' ')}>
				<td />
				<td>{dragHandle}</td>
				<td className={(!validate('vendorKey') ? 'required' : '')}>
					<select className="select" placeholder="Select" value={lineItem.viewValue('vendorKey')} onChange={e => handleUpdate('vendorKey', true, e)}>
						{ vendorOptions }
					</select>
				</td>
				<td className={(!validate('productName') ? 'required' : '')}>
					<input disabled={!!disableItemEntry} type="text" className={ 'dataList ' + disableItemEntry } 
						list={'item_' + lineItem.key} placeholder="Enter or Select" 
						value={lineItem.viewValue('productName')} 
						onChange={e => handleUpdate('productName', false, e)} 
						onBlur={e => handleUpdate('productName', true, e)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))} />
					<datalist id={'item_' + lineItem.key}>
						{ itemOptions }
					</datalist>
				</td>
				<td className={(!validate('workAreaKey') ? 'required' : '')}>
					<select disabled={!!disableItemEntry} className={ 'select ' + disableItemEntry } placeholder="Select" value={lineItem.viewValue('workAreaKey')} onChange={e => handleUpdate('workAreaKey', true, e)}>
						{ workAreaOptions }
					</select>
				</td>
				<td className={(!validate('description') ? 'required' : '')}>
					<input disabled={!!disableEntry} className={ disableEntry } type="text" placeholder="Enter" 
						autoCapitalize="" autoCorrect="off" value={lineItem.viewValue('description')} 
						onChange={e => handleUpdate('description', false, e)} 
						onBlur={e => handleUpdate('description', true, e)} 
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				</td>
				<td className="centered"><input disabled={!!disableEntry} className={ disableEntry } type="checkbox" checked={lineItem.isOptional} onChange={e => handleUpdate('isOptional', true, e)} /></td>
				<td>
					<select className={'select ' + disableEntry} placeholder="Select" value={ lineItem.contractVisibility } onChange={e => handleUpdate('contractVisibility', true, e)}>
						{ contractOptions }
					</select>
				</td>
				<td className="cost">
					<CurrencyInput disabled={disableEntry} className={ disableEntry } type="text" placeholder="0" 
						value={lineItem.viewValue('cost')} onChange={e => handleUpdate('cost', false, e)} 
						onBlur={e => handleUpdate('cost', true, e)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				</td>
				<td className={'quantity ' + ' ' + (!validate('quantity') ? 'required' : '')}>
					<NumericInput disabled={disableEntry} className={ disableEntry } type="text" placeholder="0" 
						min="0" value={lineItem.viewValue('quantity')} 
						onChange={e => handleUpdate('quantity', false, e)} 
						onBlur={e => handleUpdate('quantity', true, e)} 
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				</td>
				<td className="cost"><span className="readOnly">{ util.formatAsCurrency(lineItem.totalCost) }</span></td>
				<td className={'margin ' + ' ' + (!validate('margin') ? 'required' : '')}>
					<PercentInput disabled={disableEntry} className={ disableEntry } type="text" placeholder="0" 
						value={lineItem.viewValue('margin')} 
						onChange={e => handleUpdate('margin', false, e)} 
						onBlur={e => handleUpdate('margin', true, e)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				</td>
				<td className="cost">
					<CurrencyInput disabled={disableEntry} className={ disableEntry } type="text" placeholder="0" 
						value={lineItem.viewValue('sellPrice')} 
						onChange={e => handleUpdate('sellPrice', false, e)} 
						onBlur={e => handleUpdate('sellPrice', true, e)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				</td>
				<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
				<td />
			</tr>;
		},

		render_warehouse () { // eslint-disable-line camelcase
			const { store } = componentServices;
			const rowProps:any = { buttonClass, lineItem, handleUpdate, handleButtonClick, validate };
			rowProps.disableItemEntry = 'disabled';
			rowProps.itemOptions = [];
			const vendor = getCollection({ store, collection: ModelCollection.vendors}).find(v => v.type === enums.vendorTypes.Internal_Warehouse);

			if (vendor) {
				_.forEach(_.sortBy(vendor.products, 'sku'), product => {
					rowProps.itemOptions.push(<option key={product.key}>{product.sku}</option>);
				});

				rowProps.disableItemEntry = '';
			}

			// Define the work area options list
			rowProps.workAreaOptions = [];

			rowProps.workAreaOptions.push(<option key="unknown" value="">Select</option>);
			_.forEach(workAreas, workArea => {
				rowProps.workAreaOptions.push(<option key={workArea.key} value={workArea.key}>{workArea.name}</option>);
			});

			rowProps.contractOptions = [];
			_showOnContractFlags.forEach(flag => {
				const val = enums.jobCostLineItemReportingFlags[flag];
				const displayName = enums.jobCostLineItemReportingFlags.getDisplayName(val);
				rowProps.contractOptions.push(<option key={val} value={val}>{ displayName }</option>);
			});

			rowProps.disableEntry = 'disabled';
			if (vendor && lineItem.productName) {
				rowProps.disableEntry = (lineItem.productName === undefined) ? rowProps.disableEntry : '';
			}

			return <tr ref={ rowRef } className={rowClasses.join(' ')}>{ lineItem.isSystemManaged ? <SystemManagedWarehouseRow { ...rowProps} /> : <StandardWarehouseRow { ...rowProps} /> }</tr>;
		},

		render_misc () { // eslint-disable-line camelcase
		// Define the work area options list
			const workAreaOptions:JSX.Element[] = [];

			workAreaOptions.push(<option key="unknown" value="">Select</option>);
			_.forEach(workAreas, workArea => {
				workAreaOptions.push(<option key={workArea.key} value={workArea.key}>{workArea.name}</option>);
			});

			const contractOptions:JSX.Element[] = [];
			_showOnContractFlags.forEach(flag => {
				const val = enums.jobCostLineItemReportingFlags[flag];
				const displayName = enums.jobCostLineItemReportingFlags.getDisplayName(val);
				contractOptions.push(<option key={val} value={val}>{ displayName }</option>);
			});

			return <tr ref={ rowRef } className={rowClasses.join(' ')}>
				<td />
				<td>{dragHandle}</td>
				<td colSpan={ 5 } className={(!validate('workAreaKey') ? 'required' : '')}>
					<select className="select" placeholder="Select" value={lineItem.viewValue('workAreaKey')} onChange={e => handleUpdate('workAreaKey', true, e)}>
						{ workAreaOptions }
					</select>
				</td>
				<td className={(!validate('description') ? 'required' : '')}>
					<input type="text" placeholder="Enter" autoCapitalize="" autoCorrect="off" 
						value={lineItem.viewValue('description')} 
						onChange={e => handleUpdate('description', false, e)} 
						onBlur={e => handleUpdate('description', true, e)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))} />
				</td>
				<td className="centered"><input type="checkbox" checked={lineItem.isOptional} onChange={e => handleUpdate('isOptional', true, e)} /></td>
				<td>
					<select className={'select'} placeholder="Select" value={ lineItem.contractVisibility } onChange={e => handleUpdate('contractVisibility', true, e)}>
						{ contractOptions }
					</select>
				</td>
				<td className="cost">
					<CurrencyInput type="text" placeholder="0" value={lineItem.viewValue('cost')} 
						onChange={e => handleUpdate('cost', false, e)} 
						onBlur={e => handleUpdate('cost', true, e)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				</td>
				<td className={'margin' + ' ' + (!validate('margin') ? 'required' : '')}>
					<PercentInput type="text" placeholder="0" value={lineItem.viewValue('margin')} 
						onChange={e => handleUpdate('margin', false, e)} 
						onBlur={e => handleUpdate('margin', true, e)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				</td>
				<td className="cost">
					<CurrencyInput type="text" placeholder="0" value={lineItem.viewValue('sellPrice')} 
						onChange={e => handleUpdate('sellPrice', false, e)} 
						onBlur={e => handleUpdate('sellPrice', true, e)}
						onKeyDown={(e) => keyboardUtil.onKeyDownCallback(e, KEY_DOWN_CODES, () => handleButtonClick(e))}/>
				</td>
				<td><button className={buttonClass} onClick={handleButtonClick}><span /></button></td>
				<td />
			</tr>;
		}
	}

	return renderer[_.snakeCase('render-' + lineItem.type)]();
}

const JobCostAccesssoriesHead = ({ type }) => {
	if (type === 'outside-supplier') {
		return (<thead>
			<tr>
				<td />
				<td />
				<td className="vendor"><span className="readOnly">Vendor</span></td>
				<td className="item"><span className="readOnly">Item</span></td>
				<td className="workArea"><span className="readOnly">Work Area</span></td>
				<td className="description"><span className="readOnly">Description</span></td>
				<td className="centered"><span className="readOnly">Optional</span></td>
				<td className="showOnContract"><span className="readOnly">Show on Contract</span></td>
				<td className="cost"><span className="readOnly">Unit Cost</span></td>
				<td className="quantity"><span className="readOnly">Quantity</span></td>
				<td className="cost"><span className="readOnly">Cost</span></td>
				<td className="margin"><span className="readOnly">Margin %</span></td>
				<td className="cost"><span className="readOnly">Sell</span></td>
				<td className="action" />
				<td />
			</tr>
		</thead>);
	}
	else if (type === 'warehouse') {
		return (<thead>
			<tr>
				<td />
				<td />
				<td colSpan={ 2 } className="item"><span className="readOnly">Item</span></td>
				<td className="workArea"><span className="readOnly">Work Area</span></td>
				<td className="description"><span className="readOnly">Description</span></td>
				<td className="centered"><span className="readOnly">Optional</span></td>
				<td className="showOnContract"><span className="readOnly">Show on Contract</span></td>
				<td className="cost"><span className="readOnly">Unit Cost</span></td>
				<td className="quantity"><span className="readOnly">Quantity</span></td>
				<td className="cost"><span className="readOnly">Cost</span></td>
				<td className="margin"><span className="readOnly">Margin %</span></td>
				<td className="cost"><span className="readOnly">Sell</span></td>
				<td className="action" />
				<td />
			</tr>
		</thead>);
	}
	else if (type === 'misc') {
		return (<thead>
			<tr>
				<td />
				<td />
				<td colSpan={ 5 }><span className="readOnly">Work Area</span></td>
				<td className="description"><span className="readOnly">Description</span></td>
				<td className="centered"><span className="readOnly">Optional</span></td>
				<td className="showOnContract"><span className="readOnly">Show on Contract</span></td>
				<td className="cost"><span className="readOnly">Cost</span></td>
				<td className="margin"><span className="readOnly">Margin %</span></td>
				<td className="cost"><span className="readOnly">Sell</span></td>
				<td className="action" />
				<td />
			</tr>
		</thead>);
	}

	return null;
};

const JobCostAccessoriesSection = jobCostRowOwner({ listAccessor: model => model.lineItems, listFilterThunkFactory: props => row => row.type === props.type }, class AccessoriesSection extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(this.props);

		this.dropLineItem = this.dropLineItem.bind(this);
	}

	getStateFromProps (props) {
		const state = _.assign({ printing: false }, this.state);

		if (!state.pendingLineItem || state.pendingLineItem.type !== props.type) {
			state.pendingLineItem = this.createPendingLineItem(props);
		}

		return state;
	}

	addLineItemHandler (lineItemKey, isValid) {
		if (!isValid) {
			return;
		}

		this.props.updateModel(model => {
			if (lineItemKey === this.state.pendingLineItem.key) {
				this.state.pendingLineItem.sortIndex = this.props.getNextSortIndex(model);
				model.lineItems.add(this.state.pendingLineItem);

				this.setState({ pendingLineItem: this.createPendingLineItem(this.props) });

				this.props.sortRows(model);
			}
		}, { autoSave: true });
	}

	createPendingLineItem (props) {
		const { store } = componentServices;
		const warehouseVendor = getCollection({ store, collection: ModelCollection.vendors}).find(v => v.type === enums.vendorTypes.Internal_Warehouse);
		const { jobCost, type } = props;

		return jobCost.createLineItem({ type: type, margin: jobCost.margin || 0, vendorKey: ((type === 'warehouse') ? warehouseVendor.key : undefined) });
	}

	updateModel (key, updater, options) {
		this.props.updateModel((jobCost, lineUpdateCallback) => {
			let lineItem = jobCost.lineItems.get(key);

			if ((!lineItem) && (key === this.state.pendingLineItem.key)) {
				lineItem = this.state.pendingLineItem;
				options.autoSave = false;
			}

			if (lineItem) {
				updater(lineItem, lineUpdateCallback);
			}
		}, options);
	}

	dropLineItem (sourceKey, targetKey) {
		this.props.updateModel(jobCost => {
			const sourceItem = jobCost.lineItems.get(sourceKey);
			const targetItem = jobCost.lineItems.get(targetKey);

			this.props.handleItemDrop(jobCost, sourceItem, targetItem);
		}, { autoSave: true });
	}

	render () {
		//<!-- Applying the class "dropTarget" to any TR will turn the bottom border color green to indicate that is where a row being dragged will be dropped -->
		const { jobCost, getRowClasses, printReport, rowContextMenuHandler, summary, type, showHeader, updateModel, ...childProps } = this.props;
		const typeName = _.startCase(type);
		const pascalName = typeName.replace(' ', '');
		const lineItems = _.map(_.sortBy(jobCost.getLineItemsByType(type), 'sortIndex'), item => {
			return (
				<JobCostAccessoriesRow key={item.rowKey} updateModel={this.updateModel.bind(this, item.key)} dropLineItem={ this.dropLineItem } buttonHandler={ rowContextMenuHandler.bind(this, item)} lineItem={item} classNames={ getRowClasses({ item: item }) } buttonClass="icon iconOnly contextMenu" draggable={true} alwaysValidate={true} workAreas={ jobCost.workAreas } {...childProps}/>
			);
		});
		const taxCost = summary.calculatePreSubtotalTaxCost('order', type);
		const table = (<div className="inner">

			<table className="compact draggable" cellPadding="0" cellSpacing="0">
				<JobCostAccesssoriesHead type={type} />
				<tbody>
					<JobCostHiddenWhenLocked jobCost={ jobCost }>
						<JobCostAccessoriesRow key={ this.state.pendingLineItem.key } 
							updateModel={this.updateModel.bind(this, this.state.pendingLineItem.key)} 
							buttonHandler={this.addLineItemHandler.bind(this, this.state.pendingLineItem.key)} 
							lineItem={this.state.pendingLineItem} classNames={ ['addRow'] } 
							buttonClass="icon iconOnly addItem" draggable={false} 
							workAreas={ jobCost.workAreas } {...childProps}/>
					</JobCostHiddenWhenLocked>
					{ lineItems }
				</tbody>
				<tfoot className="subtotal">
					<tr>
						<td />
						<td />
						<td />
						<td />
						<td />
						<td />
						<td />
						<td className="cost" colSpan={ 4 }>{ typeName } Cost Subtotal</td>
						<td className="cost" colSpan={ 2 }>{ util.formatAsCurrency(summary[`order${pascalName}Cost`]) }</td>
						<td />
						<td />
					</tr>
					{ taxCost ? <tr>
						<td />
						<td />
						<td />
						<td />
						<td />
						<td />
						<td />
						<td className="cost" colSpan={ 4 }>{ typeName } Tax Cost</td>
						<td className="cost" colSpan={ 2 }>{ util.formatAsCurrency(taxCost) }</td>
						<td />
						<td />
					</tr> : null
					}
					<tr>
						<td />
						<td />
						<td />
						<td />
						<td />
						<td />
						<td />
						<td className="cost" colSpan={ 4 }>{ typeName } Sell Subtotal</td>
						<td className="cost" colSpan={ 2 }>{ util.formatAsCurrency(summary[`order${pascalName}Sell`]) }</td>
						<td />
						<td />
					</tr>
				</tfoot>
			</table>
		</div>);

		return showHeader ? (
			<section>
				<header>
					<span>{_.startCase(type)}</span>
					<div className="actions">
						<AsyncButton className="print" asyncAction={ printReport } label="Print" />
					</div>
				</header>
				{ table }
			</section>
		) : table;
	}
});


export default function JobCostEditAccessoriesMods({ fetchReport, jobCost, summary, store, updateModel }: IJobCostChildProps) {
	useEffect(() => {
		vendorActions.fetchVendors({ type: enums.vendorTypes.Outside_Supplier | enums.vendorTypes.Internal_Warehouse });
	}, []);

	const vendors = getCollection({ store, collection: ModelCollection.vendors }).filter(v => {
		return ((v.type === enums.vendorTypes.Outside_Supplier) || (v.type === enums.vendorTypes.Internal_Warehouse));
	}).sortBy(v => v.name);
	const warehouseVendor = vendors.find(v => v.type === enums.vendorTypes.Internal_Warehouse);
	const types = (warehouseVendor) ? _jobCostLineItemTypes : _.filter(_jobCostLineItemTypes, t => t !== 'warehouse');
	const titlebarActions = [<AsyncButton className="pdf" asyncAction={ () => fetchReport('internal/outside-supplier') } label="Print" />];

	const sections = _.map(types, type => {
		return (
			<JobCostAccessoriesSection key={type} updateModel={ updateModel } jobCost={ jobCost } summary={ summary } printReport={ () => fetchReport(`internal/${type}`) } type={type} vendors={vendors} showHeader={ type !== 'outside-supplier'} />
		);
	});

	return (
		<section>
			<Header title="Outside Supplier" actions={ titlebarActions } />
			<div className="jobCostAccessoriesMods">
				{sections}
			</div>
		</section>

	);
}